function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { CssContainer, Container } from "../../components/container";
import { PageHeader, Ribbon, Card, Pill, Empty, Search, Filters } from "../../components/analytics-kit";
import Error from "../../components/error";
import Auth from "../../functions/authenticate";
import PlunkDropDown from "../../components/plunk-dropdown";
import { KpiStrip, Kpi } from "../../components/card";
import { hasTenantFeature, adBillingMode, ownAdAccounts } from "../../functions/tenant-features";
import account from "../../data/account";
// Imported Shopify marketing activities ride the campaign table with provider 'Shopify' (Autopilot Phase A).
const isImported = r => String(r && r.provider || "").toLowerCase() === "shopify";
const importedApp = r => {
  try {
    const md = typeof r.metaData === "string" ? JSON.parse(r.metaData) : r.metaData || r.meta_data || {};
    return (typeof md === "string" ? JSON.parse(md) : md).app || "Shopify";
  } catch (e) {
    return "Shopify";
  }
};
import { adSvc, FETCH_SLICES, parseName, channelLabel, num, usd, pct, budgetUsd, budgetDollars, aggregate, readSliceCache, writeSliceCache, isActiveStatus, fetchAllCampaigns, readAllCache, writeAllCache, clearAllCache, rangeQs, DEFAULT_RANGE, ALL_CHANNEL_LABELS } from "./common";
import RangePicker from "../../components/range-picker";
import CampaignsNav from "./nav";
import { RANGES, rangeLabelFor } from "../sales/territory-common";
import { getGlobalRange, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";

/*
 * Ad Campaigns dashboard — Phase A, READ-ONLY (AD_CAMPAIGNS spec §3).
 * Flight-grouped table over the deployed CampaignService reads.
 *
 * §2.5 money rule: managed tenants (adBillingMode) never see Spend / CPC /
 * CPM / budget — FE gate here, server-side omission is the Phase B
 * boundary. §2.6 white-label: channel labels only, no provider, ever.
 *
 * Progressive load: (type × status) slices fetched in parallel (the
 * unfiltered list 504s — at-scale endpoint ask filed); each slice renders
 * as it lands. Metrics are LIFETIME (range=DAY sums the per-day stat
 * rows) — labeled as such; date windows arrive with the at-scale API.
 * Pause/budget-edit are Phase B; deletes are Phase C by spec.
 */

const STATUS_OPTS = [["", "All statuses"], ["active", "Active"], ["paused", "Paused"], ["Removed", "Deleted"]];
const isRemovedStatus = s => /^(removed|deleted)$/i.test(String(s || ""));
const GROUP_OPTS = [["flight", "Group by flight"], ["market", "Group by market"], ["flat", "Flat list"]];
const FLIGHTS_PAGE = 25;
class CampaignsViewComponent extends React.Component {
  constructor(props) {
    super(props);
    // ?q= deep-link support (federated search + MI cross-links land here
    // pre-filtered).
    // §213/§215: the whole load re-runs per range window — caches are keyed
    // by (tenant, range) so flipping back to a seen window is instant.
    _defineProperty(this, "refresh", () => {
      this.setState({
        shownFlights: FLIGHTS_PAGE
      });
      this.loadCampaigns(this.state.range, true);
      adSvc("/flights").getAsync().then(rows => this._alive && this.setState({
        flightRows: Array.isArray(rows) ? rows : []
      }, () => this.checkStaleCache())).catch(() => {});
    });
    _defineProperty(this, "openFlight", id => this.props.history.push(`/Campaigns/flight/${id}`));
    _defineProperty(this, "cleanupRemoved", () => {
      this.setState({
        cleaning: true
      });
      adSvc("/flights/cleanup").postAsync({}).then(() => setTimeout(() => {
        if (this._alive) {
          this.setState({
            cleaning: false
          });
          this.refresh();
        }
      }, 4000)).catch(() => this._alive && this.setState({
        cleaning: false
      }));
    });
    _defineProperty(this, "openCampaign", id => () => this.props.history.push(`/Campaigns/detail/${id}`));
    const params = new URLSearchParams(props.location && props.location.search || "");
    this.state = {
      rows: [],
      pendingSlices: FETCH_SLICES.length,
      failedSlices: 0,
      q: params.get("q") || "",
      statusFilter: "",
      channelFilter: "",
      grouping: "flight",
      range: params.get("range") || getGlobalRange(DEFAULT_RANGE),
      noDeliveryOnly: false,
      expanded: {},
      shownFlights: FLIGHTS_PAGE,
      error: false,
      tab: "campaigns",
      flightRows: null // §96 list slice: GET /flights (drafts + in-progress)
    };
    this._alive = true;
  }
  async componentDidMount() {
    if (ownAdAccounts()) {
      try {
        const svc = adSvc("/provider-settings");
        Promise.resolve(svc.getAsync()).then(rows => {
          const arr = Array.isArray(rows) ? rows : rows && (rows.settings || rows.items) || [];
          const g = arr.find(r => String(r.provider || "").toLowerCase() === "google") || {};
          const f = arr.find(r => String(r.provider || "").toLowerCase() === "facebook") || {};
          this.setState({
            providerSettingsLoaded: true,
            providerSettingsOk: !!(g.clientId || f.accountId && f.pageId)
          });
        }).catch(() => this.setState({
          providerSettingsLoaded: true,
          providerSettingsOk: false
        }));
      } catch (e) {
        this.setState({
          providerSettingsLoaded: true,
          providerSettingsOk: false
        });
      }
    }
    if (!(Auth.isAuthenticated() || (await Auth.attachOrSignIn()))) return;
    // §96 flights list — non-blocking; renders a strip above the grid.
    adSvc("/flights").getAsync().then(rows => this._alive && this.setState({
      flightRows: Array.isArray(rows) ? rows : []
    }, () => this.checkStaleCache())).catch(() => this._alive && this.setState({
      flightRows: []
    }));
    this.loadCampaigns(this.state.range);
    this._periodTok = subscribePeriod(({
      range
    }) => {
      if (!this._alive || !range || range === this.state.range) return;
      this.setState({
        range,
        shownFlights: FLIGHTS_PAGE
      });
      this.loadCampaigns(range);
    });
  }
  // Match a campaign-derived flight group (parsed name) back to a flight
  // record (GET /flights) so the list row can link to detail + pause/resume.
  resolveFlightId(group) {
    const n = String(group && group.flight || group || "").toLowerCase().trim();
    if (!n) return null;
    // Normalize a channel (label OR stored key) to a common base so a
    // group's labels ("Retargeting") match a flight's keys ("Retarget").
    const nc = c => String(c || "").toLowerCase().replace("retargeting", "retarget").replace(/social ?video/g, "socialvideo").replace(/ctv.*/g, "ctv").replace(/[^a-z]/g, "");
    const groupChans = new Set([...(group && group.channels || [])].map(nc));
    const matches = (this.state.flightRows || []).filter(fr => {
      const ev = String(fr.eventName || fr.name || "").toLowerCase().trim();
      return ev && (n === ev || n.endsWith(" " + ev) || n.indexOf(ev) >= 0);
    });
    if (!matches.length) return null;
    // Pick the name-match whose channels best overlap this row's campaigns.
    let best = matches[0],
      bestScore = -1;
    matches.forEach(fr => {
      const frChans = new Set((fr.channels || []).map(nc));
      let score = 0;
      groupChans.forEach(c => {
        if (frChans.has(c)) score++;
      });
      if (score > bestScore) {
        bestScore = score;
        best = fr;
      }
    });
    // When we know the row's channels and NONE overlap the matched flight,
    // these campaigns don't belong to it — it's only a name coincidence
    // (e.g. this row is a soft-deleted flight's orphaned campaigns). Don't
    // link, rather than point details/edit/pause at the wrong flight.
    if (groupChans.size > 0 && bestScore <= 0) return null;
    return best ? best.id : null;
  }
  flightAction(id, status) {
    if (!id || this.state.flightBusy) return;
    this.setState({
      flightBusy: id
    });
    adSvc(`/flights/${id}/status?status=${status}`).putAsync({}).then(() => {
      if (this._alive) {
        this.setState({
          flightBusy: null
        });
        this.refresh();
      }
    }).catch(() => this._alive && this.setState({
      flightBusy: null
    }));
  }
  // Group-level fallbacks — act directly on the group's campaigns by id, for
  // groups that don't resolve to a flight record (e.g. legacy per-tier campaign
  // names, or a flight that was soft-deleted). Pause/resume set status; remove
  // deletes each campaign row.
  groupStatus(rows, status) {
    const ids = (rows || []).filter(r => !isRemovedStatus(r.status)).map(r => r.id);
    if (!ids.length || this.state.flightBusy) return;
    this.setState({
      flightBusy: ids[0]
    });
    Promise.all(ids.map(cid => adSvc(`/campaigns/${cid}/status?status=${status}`).putAsync({}).catch(() => {}))).then(() => {
      if (this._alive) {
        this.setState({
          flightBusy: null
        });
        this.refresh();
      }
    });
  }
  groupRemove(f) {
    const ids = (f.rows || []).map(r => r.id);
    if (!ids.length || this.state.flightBusy) return;
    if (!window.confirm(`Remove ${ids.length} campaign${ids.length === 1 ? "" : "s"} under "${f.flight}" from Plunk? Pause them at the ad network first if they're still live.`)) return;
    this.setState({
      flightBusy: ids[0]
    });
    Promise.all(ids.map(cid => adSvc(`/campaigns/${cid}`).deleteAsync().catch(() => {}))).then(() => {
      if (this._alive) {
        this.setState({
          flightBusy: null
        });
        this.refresh();
      }
    });
  }
  // Soft-delete: pauses every live campaign the flight created, then marks it
  // Deleted (DELETE /flights/{id}). Removed flights drop off the list.
  deleteFlight(id, name) {
    if (!id || this.state.flightBusy) return;
    if (!window.confirm(`Delete flight "${name || id}"? This pauses all its campaigns and removes it from the list.`)) return;
    this.setState({
      flightBusy: id
    });
    adSvc(`/flights/${id}`).deleteAsync().then(() => {
      if (this._alive) {
        this.setState({
          flightBusy: null
        });
        this.refresh();
      }
    }).catch(() => this._alive && this.setState({
      flightBusy: null
    }));
  }
  async loadCampaigns(range, force) {
    // Bounded concurrency (3) + one retry pass: all 8 slices at once
    // contend the backend past the gateway's 29s cap (each slice does
    // the N+1 stats join server-side — the Track-1 batched-query fix is
    // with meanstream). Enabled slices queue first; fresh cache hits
    // (15-min TTL) resolve instantly. Progressive render either way.
    const tenantId = (account.get() || {}).tenantId || "";
    this._loadSeq = (this._loadSeq || 0) + 1;
    const seq = this._loadSeq;
    const live = () => this._alive && seq === this._loadSeq;
    this.setState({
      rows: [],
      pendingSlices: FETCH_SLICES.length,
      failedSlices: 0
    });
    // Fast path first: cache, then the single unfiltered call (1.0.2
    // backend). Falls through to the slice strategy on failure.
    if (force) clearAllCache(tenantId);
    const cachedAll = force ? null : readAllCache(tenantId, range);
    if (cachedAll) {
      this._rowsFromCache = true;
      this.setState({
        rows: cachedAll,
        pendingSlices: 0
      }, () => this.checkStaleCache());
      return;
    }
    this._rowsFromCache = false;
    try {
      const all = await fetchAllCampaigns(adSvc, range);
      if (!live()) return;
      writeAllCache(tenantId, all, range);
      this.setState({
        rows: all,
        pendingSlices: 0
      });
      return;
    } catch (e) {/* pre-1.0.2 backend — slice fallback below */}
    const queue = [];
    FETCH_SLICES.forEach(slice => {
      const cached = readSliceCache(tenantId, slice, range);
      if (cached) {
        this.setState(st => ({
          rows: [...st.rows, ...cached],
          pendingSlices: st.pendingSlices - 1
        }));
      } else {
        queue.push({
          ...slice
        });
      }
    });
    const retryable = [];
    const runNext = async () => {
      const slice = queue.shift();
      if (!slice) return;
      try {
        const d = await adSvc(`/campaigns?type=${slice.type}&status=${slice.status}&${rangeQs(range)}`).getAsync();
        if (!live()) return;
        const rows = d && d.campaigns || [];
        writeSliceCache(tenantId, slice, rows, range);
        this.setState(st => ({
          rows: [...st.rows, ...rows],
          pendingSlices: st.pendingSlices - 1
        }));
      } catch (e) {
        if (!slice._retried) {
          slice._retried = true;
          retryable.push(slice);
        } else if (live()) this.setState(st => ({
          pendingSlices: st.pendingSlices - 1,
          failedSlices: st.failedSlices + 1
        }));
      }
      if (!queue.length && retryable.length) queue.push(...retryable.splice(0));
      await runNext();
    };
    [0, 1, 2].forEach(() => runNext());
  }
  componentWillUnmount() {
    this._alive = false;
    unsubscribePeriod(this._periodTok);
  }
  // The campaign rows carry a 15-minute session cache. A flight that finished
  // launching after the cache was written has no campaign group yet, so it would
  // vanish from the list (completed flights only render as their group). When a
  // completed flight resolves to no group, the cache is stale: refetch once.
  checkStaleCache() {
    if (!this._alive || !this._rowsFromCache || this.state.pendingSlices > 0) return;
    const fr = this.state.flightRows || [];
    if (!fr.length) return;
    const ids = new Set(this.groups(this.state.rows || [], "flight").map(g => String(this.resolveFlightId(g) || "")).filter(Boolean));
    const missing = fr.filter(f => String(f.status || "").toLowerCase().startsWith("completed") && !ids.has(String(f.id || f.Id || "")));
    if (!missing.length) return;
    const key = missing.map(f => String(f.id || f.Id)).sort().join(",");
    if (this._staleKey === key) return;
    this._staleKey = key;
    this._rowsFromCache = false;
    this.loadCampaigns(this.state.range, true);
  }
  filtered() {
    const {
      rows,
      q,
      statusFilter,
      channelFilter,
      noDeliveryOnly
    } = this.state;
    const needle = q.trim().toLowerCase();
    return rows.filter(r => {
      if (noDeliveryOnly && !(!isImported(r) && isActiveStatus(r.status) && !(Number((r.metrics || {}).impressions) > 0))) return false;
      if (statusFilter === "Removed") {
        if (!isRemovedStatus(r.status)) return false;
      } else {
        if (isRemovedStatus(r.status)) return false; // deleted flights hidden unless the Deleted filter is chosen
        if (statusFilter === "active" && !isActiveStatus(r.status)) return false;
        if (statusFilter === "paused" && isActiveStatus(r.status)) return false;
      }
      if (channelFilter === "Imported") {
        if (!isImported(r)) return false;
      } else if (channelFilter && channelLabel(r.type) !== channelFilter) return false;
      if (needle) {
        const p = parseName(r.name);
        if (!`${r.name} ${p.flight} ${p.market}`.toLowerCase().includes(needle)) return false;
      }
      return true;
    });
  }
  groups(rows, by) {
    const map = new Map();
    rows.forEach(r => {
      const p = parseName(r.name);
      const key = by === "market" ? p.market || "(no market)" : p.flight;
      const f = map.get(key) || {
        flight: key,
        rows: [],
        channels: new Set(),
        markets: new Set(),
        enabled: 0,
        paused: 0,
        removed: 0
      };
      f.rows.push({
        ...r,
        _market: p.market
      });
      f.channels.add(channelLabel(r.type));
      f.markets.add(by === "market" ? p.flight : p.market || "");
      if (isRemovedStatus(r.status)) f.removed += 1;else if (isActiveStatus(r.status)) f.enabled += 1;else f.paused += 1;
      map.set(key, f);
    });
    return [...map.values()].map(f => ({
      ...f,
      agg: aggregate(f.rows),
      // most recent activity across the flight's campaigns (last stats /
      // modified date — no true last-stats field is on the list payload)
      lastActivity: Math.max(0, ...f.rows.map(r => {
        const d = new Date(r.date || r.modifiedDate || r.createdDate || 0).getTime();
        return Number.isFinite(d) ? d : 0;
      }))
    }))
    // status first (any active campaign on top), then most recent activity, then volume
    .sort((a, b) => Number(b.enabled > 0) - Number(a.enabled > 0) || b.lastActivity - a.lastActivity || b.agg.impressions - a.agg.impressions);
  }

  // Insights: superlative reads over the loaded (filtered) rows — the
  // spec's "keep the original's superlative cards" as a tab.
  insights(rows) {
    const withImpr = rows.filter(r => Number((r.metrics || {}).impressions) > 0);
    const byCtr = withImpr.filter(r => Number((r.metrics || {}).impressions) >= 1000).slice().sort((a, b) => Number((b.metrics || {}).ctr) - Number((a.metrics || {}).ctr));
    const byClicks = withImpr.slice().sort((a, b) => Number((b.metrics || {}).clicks) - Number((a.metrics || {}).clicks));
    const flights = this.groups(rows, "flight");
    const markets = this.groups(rows, "market").filter(g => g.flight !== "(no market)");
    const channels = {};
    rows.forEach(r => {
      const c = channelLabel(r.type);
      channels[c] = channels[c] || {
        channel: c,
        rows: []
      };
      channels[c].rows.push(r);
    });
    const channelAgg = Object.values(channels).map(c => ({
      ...c,
      agg: aggregate(c.rows)
    })).sort((a, b) => b.agg.impressions - a.agg.impressions);
    return {
      byCtr: byCtr.slice(0, 5),
      byClicks: byClicks.slice(0, 5),
      topFlights: flights.slice(0, 5),
      topMarkets: markets.slice(0, 5),
      channelAgg
    };
  }
  renderCampaignRow(r, moneyVisible, indent) {
    const m = r.metrics || {};
    const p = parseName(r.name);
    // Imported from Shopify Marketing (Autopilot, Shopify Email, channel apps): no Plunk detail page,
    // no spend/impressions from Shopify — sessions, orders and revenue are Plunk-measured.
    const imported = isImported(r);
    const noDelivery = !imported && isActiveStatus(r.status) && !(Number(m.impressions) > 0);
    return /*#__PURE__*/React.createElement("tr", {
      key: r.id,
      className: imported ? undefined : "clickable",
      onClick: imported ? undefined : this.openCampaign(r.id),
      title: imported ? "Imported from Shopify Marketing — measured by Plunk from site traffic" : "Open campaign detail"
    }, /*#__PURE__*/React.createElement("td", {
      style: indent ? {
        paddingLeft: "28px"
      } : undefined
    }, /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, imported ? r.name : p.market || p.flight), /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, channelLabel(r.type)), imported && /*#__PURE__*/React.createElement("span", {
      className: "code",
      style: {
        marginLeft: 4,
        background: "#eef0f3",
        color: "#55606e"
      }
    }, "Imported \xB7 ", importedApp(r))), /*#__PURE__*/React.createElement("td", null, isActiveStatus(r.status) ? /*#__PURE__*/React.createElement("span", {
      className: "cust-stage",
      style: {
        background: "#e5f3ec",
        color: "#217a4b"
      }
    }, "active") : /*#__PURE__*/React.createElement("span", {
      className: "cust-stage",
      style: {
        background: "var(--plk-surface-alt)",
        color: "var(--plk-text-dim)"
      }
    }, "paused"), channelLabel(r.type) === "CTV/OTT" && /*#__PURE__*/React.createElement("span", {
      className: "cust-stage",
      style: {
        background: "var(--plk-accent-soft, #fdeeec)",
        color: "var(--plk-accent, #ff6358)",
        marginLeft: "4px"
      },
      title: "Stats are loaded monthly by your account team"
    }, "managed channel"), noDelivery && /*#__PURE__*/React.createElement("span", {
      className: "cust-stage",
      style: {
        background: "#f9f0dc",
        color: "#9a6b15",
        marginLeft: "4px"
      },
      title: "Active with no recorded impressions"
    }, "no delivery")), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(m.impressions)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(m.clicks)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, pct(m.ctr)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(m.conversions)), this._videoOn ? /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, Number(m.videoViews) > 0 ? num(m.videoViews) : "—") : null, this._roasOn ? /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, Number(m.revenue) > 0 ? usd(m.revenue) : "—") : null, this._roasOn ? /*#__PURE__*/React.createElement("td", {
      className: "r strong"
    }, Number(m.roas) > 0 ? `${Number(m.roas).toFixed(2)}×` : "—") : null, this._roasOn ? /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, Number(m.cpa) > 0 ? usd(m.cpa) : "—") : null, moneyVisible ? /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, usd(m.spend)) : null, moneyVisible ? /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, budgetUsd(r.budget, r.provider) ? `${budgetUsd(r.budget, r.provider)}/day` : "—") : null);
  }
  render() {
    if (!hasTenantFeature("campaigns")) {
      // §213 gate copy: say WHAT gets enabled; self-managed tenants also
      // need their ad-provider connection, so point them at Settings.
      return /*#__PURE__*/React.createElement(CssContainer, {
        cls: "margin-squeeze"
      }, /*#__PURE__*/React.createElement("p", {
        className: "module-empty"
      }, "Ad Campaigns isn't set up for this workspace yet. Once enabled you get the flight dashboard, per-campaign performance, and creative insights across your ad channels \u2014 contact Plunk to turn it on.", adBillingMode() === "selfmanaged" && /*#__PURE__*/React.createElement(React.Fragment, null, " Self-managed advertisers also connect their ad accounts under", " ", /*#__PURE__*/React.createElement("a", {
        style: {
          cursor: "pointer"
        },
        onClick: () => this.props.history.push("/Campaigns/Settings")
      }, "Provider Settings"), ".")));
    }
    const {
      pendingSlices,
      failedSlices,
      q,
      statusFilter,
      channelFilter,
      grouping,
      expanded,
      shownFlights,
      error
    } = this.state;
    const isFlightAdmin = ((account.get() || {}).groups || []).some(g => ["owner", "administrator", "root"].includes(String(g).toLowerCase()));
    if (error) return /*#__PURE__*/React.createElement(Error, null);
    const moneyVisible = adBillingMode() === "selfmanaged";
    // Own ad accounts (Shopify Commerce): campaigns need the tenant's Google / Meta ids.
    const needsAccounts = ownAdAccounts() && this.state.providerSettingsLoaded && !this.state.providerSettingsOk;
    const rows = this.filtered();
    const totals = aggregate(rows);
    const loading = pendingSlices > 0;
    // Every channel the platform sells, plus anything the data carries — not just the types present today.
    const channels = [...new Set([...ALL_CHANNEL_LABELS, ...this.state.rows.map(r => channelLabel(r.type))])];
    const flights = grouping !== "flat" ? this.groups(rows, grouping) : null;
    // Drafts / in-progress flights have no campaigns yet, so they never appear as
    // groups. Surface them at the top of the Flights table (and through the same
    // search box) instead of a separate picker — scales to thousands.
    const qq = String(this.state.q || "").trim().toLowerCase();
    const groupNames = new Set((flights || []).map(f => String(f.flight || "").toLowerCase()));
    // Dedup launched flights (already shown as their campaign group) by flight
    // ID, not name — two flights can share a name (e.g. a draft reusing the
    // name of a live flight), and a name-only dedup silently hid the draft.
    // resolveFlightId matches a group to its flight by name + channel overlap,
    // so a same-named draft on different channels resolves to a different id
    // and survives. Drafts have no campaigns, so they're never a group dup.
    const groupIds = new Set((flights || []).map(f => String(this.resolveFlightId(f) || "")).filter(Boolean));
    const pendingFlights = grouping === "flight" ? (this.state.flightRows || []).filter(f => {
      const st = String(f.status || "").toLowerCase();
      if (["completed", "deleted"].includes(st)) return false;
      if (qq && !`${f.eventName || ""} ${f.name || ""} ${f.status || ""}`.toLowerCase().includes(qq)) return false;
      if (st === "draft") return true;
      const idStr = String(f.id || f.Id || "");
      if (idStr && groupIds.has(idStr)) return false;
      // Fallback only when no group ids resolved at all: legacy name dedup.
      if (!groupIds.size && groupNames.has(String(f.eventName || f.name || "").toLowerCase())) return false;
      return true;
    }) : [];
    const noDeliveryCount = rows.filter(r => !isImported(r) && isActiveStatus(r.status) && !(Number((r.metrics || {}).impressions) > 0)).length;
    // §94 attributed ROAS — build-behind-the-flag: the server overlays
    // revenue/roas/cpa onto metrics ONLY when the tenant's RoasVisible
    // flag is on (fail-closed; money scrubber strips for managed). The
    // columns key on the data actually being present, so nothing shows
    // until DS flips a tenant's flag.
    const roasOn = rows.some(r => Number((r.metrics || {}).revenue) > 0 || Number((r.metrics || {}).roas) > 0);
    this._roasOn = roasOn && grouping === "flat";
    this._videoOn = rows.some(r => Number(((r || {}).metrics || {}).videoViews) > 0);
    const cols = (moneyVisible ? 8 : 6) + (this._roasOn ? 3 : 0) + (this._videoOn ? 1 : 0);
    return /*#__PURE__*/React.createElement(React.Fragment, null, needsAccounts && /*#__PURE__*/React.createElement(CssContainer, {
      cls: "margin-squeeze"
    }, /*#__PURE__*/React.createElement("p", {
      className: "module-empty",
      style: {
        borderLeft: "3px solid var(--plk-accent, #ff6358)"
      }
    }, /*#__PURE__*/React.createElement("b", null, "Connect your ad accounts."), " Your campaigns run on your own Google Ads and Meta accounts \u2014 you pay the ad platforms directly. Connect them once under", " ", /*#__PURE__*/React.createElement("a", {
      style: {
        cursor: "pointer"
      },
      onClick: () => this.props.history.push("/Campaigns/Settings")
    }, "Campaigns \u203A Settings"), " and flights can launch.")), /*#__PURE__*/React.createElement("div", {
      className: "territory-view campaigns-view wa-view"
    }, !this.state.loading && !pendingSlices && !(this.state.rows || []).length && /*#__PURE__*/React.createElement(CssContainer, {
      cls: "margin-squeeze"
    }, /*#__PURE__*/React.createElement("p", {
      className: "module-empty"
    }, /*#__PURE__*/React.createElement("b", null, "No campaigns yet."), " ", hasTenantFeature("shopify") ? "Plunk works alongside Shopify Autopilot. Autopilot runs your Meta and Shop campaigns; Plunk adds Google Search, Performance Max, YouTube and CTV, email journeys, demand forecasting, Studio creative, and attribution across your store, POS, ERP and wholesale sales, all in one place." : "Plunk runs Google Search, Performance Max, Display, YouTube and CTV, and Meta campaigns, plus email journeys, demand forecasting, Studio creative, and attribution across your store, POS, ERP and wholesale sales, all in one place.", " ", /*#__PURE__*/React.createElement("a", {
      style: {
        cursor: "pointer"
      },
      onClick: () => this.props.history.push("/Campaigns/Autopilot")
    }, "Let Autopilot draft your first flights"), " or build one in the flight builder.")), /*#__PURE__*/React.createElement(CampaignsNav, {
      active: "flights",
      history: this.props.history,
      subtitle: `Every flight and campaign with live delivery · ${num((this.state.rows || []).length)} campaigns loaded${noDeliveryCount ? ` · ${noDeliveryCount} active with no delivery` : ""}`,
      actions: /*#__PURE__*/React.createElement(React.Fragment, null, ((account.get() || {}).groups || []).some(g => ["owner", "administrator", "root"].includes(String(g).toLowerCase())) && /*#__PURE__*/React.createElement(React.Fragment, null, (moneyVisible || ((account.get() || {}).groups || []).some(g => ["administrator", "root"].includes(String(g).toLowerCase()))) && /*#__PURE__*/React.createElement("button", {
        className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
        onClick: () => this.props.history.push("/Campaigns/FlightBuilder")
      }, "New flight"), /*#__PURE__*/React.createElement("button", {
        className: "territory-back",
        title: "Ad Provider Settings (\xA798)",
        onClick: () => this.props.history.push("/Campaigns/Settings")
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "settings"))), /*#__PURE__*/React.createElement(PlunkDropDown, {
        width: "160px",
        value: channelFilter,
        onChange: v => this.setState({
          channelFilter: v,
          shownFlights: FLIGHTS_PAGE
        }),
        options: [["", "All channels"], ...channels.map(c => [c, c]), ...(this.state.rows.some(isImported) ? [["Imported", "Imported (Shopify)"]] : [])]
      }), /*#__PURE__*/React.createElement(PlunkDropDown, {
        width: "140px",
        value: statusFilter,
        onChange: v => this.setState({
          statusFilter: v,
          shownFlights: FLIGHTS_PAGE
        }),
        options: STATUS_OPTS
      }), /*#__PURE__*/React.createElement(PlunkDropDown, {
        width: "170px",
        value: grouping,
        onChange: v => this.setState({
          grouping: v,
          shownFlights: FLIGHTS_PAGE
        }),
        options: GROUP_OPTS
      }), isFlightAdmin && /*#__PURE__*/React.createElement("button", {
        className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
        disabled: this.state.cleaning,
        title: "Re-pause lingering campaigns on removed flights so already-removed ones drop off the list",
        onClick: this.cleanupRemoved
      }, this.state.cleaning ? "Cleaning…" : "Clean up removed"), /*#__PURE__*/React.createElement("button", {
        className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
        title: "Reload live campaign data (clears the 15-min cache)",
        onClick: this.refresh
      }, "Refresh"))
    }), /*#__PURE__*/React.createElement(CssContainer, {
      cls: "margin-squeeze"
    }, /*#__PURE__*/React.createElement(Ribbon, {
      comparing: null,
      cols: 4,
      tiles: [{
        l: "Impressions",
        v: num(totals.impressions),
        s: Number(totals.videoViews) > 0 ? `${num(totals.videoViews)} video views` : null
      }, {
        l: "Clicks",
        v: num(totals.clicks),
        s: `${pct(totals.ctr)} CTR`
      }, {
        l: "Conversions",
        v: num(totals.conversions),
        s: roasOn && Number(totals.revenue) > 0 ? `${usd(totals.revenue)} attributed revenue` : null
      }, moneyVisible ? {
        l: "Spend",
        v: usd(totals.spend),
        s: [Number(totals.cpc) > 0 ? `${usd(totals.cpc)} CPC` : null, roasOn && Number(totals.roas) > 0 ? `${Number(totals.roas).toFixed(2)}× ROAS` : null].filter(Boolean).join(" · ") || null
      } : {
        l: "Video views",
        v: num(totals.videoViews)
      }]
    }), noDeliveryCount || this.state.noDeliveryOnly ? /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        marginTop: "6px"
      }
    }, /*#__PURE__*/React.createElement("a", {
      style: {
        color: "#9a6b15",
        cursor: "pointer",
        textDecoration: this.state.noDeliveryOnly ? "underline" : "none"
      },
      title: "Active campaigns with zero recorded impressions in this window \u2014 click to filter to just these",
      onClick: () => this.setState({
        noDeliveryOnly: !this.state.noDeliveryOnly,
        shownFlights: FLIGHTS_PAGE
      })
    }, this.state.noDeliveryOnly ? "showing only no-delivery — clear" : `${noDeliveryCount} active with no delivery`)) : null), noDeliveryCount > 0 && !this.state.noDeliveryOnly && /*#__PURE__*/React.createElement(CssContainer, {
      cls: "margin-squeeze"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: () => this.setState({
        noDeliveryOnly: true,
        shownFlights: FLIGHTS_PAGE
      }),
      title: "Active campaigns with zero recorded impressions in this window \u2014 click to filter to just these",
      style: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "11px 14px",
        background: "#fbf1e2",
        border: "1px solid #e8cf9a",
        borderRadius: "10px",
        color: "#8a5a12",
        cursor: "pointer",
        fontSize: "13.5px"
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons",
      style: {
        fontSize: "20px",
        flex: "0 0 auto"
      }
    }, "warning_amber"), /*#__PURE__*/React.createElement("span", {
      style: {
        flex: "1 1 auto"
      }
    }, /*#__PURE__*/React.createElement("strong", null, noDeliveryCount, " active campaign", noDeliveryCount === 1 ? "" : "s", " ", noDeliveryCount === 1 ? "is" : "are", " not delivering"), " \u2014 running but recording zero impressions in this window. Check targeting, budget, or account status."), /*#__PURE__*/React.createElement("span", {
      style: {
        fontWeight: 700,
        whiteSpace: "nowrap"
      }
    }, "Show these \u2192"))), false ? (() => {
      const ins = this.insights(rows);
      const groupTable = (title, groups, label) => /*#__PURE__*/React.createElement(Card, {
        title: title
      }, /*#__PURE__*/React.createElement("table", {
        className: "territory-table wa-table"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, label), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Campaigns"), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Impressions"), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Clicks"), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "CTR"))), /*#__PURE__*/React.createElement("tbody", null, groups.map(g => /*#__PURE__*/React.createElement("tr", {
        key: g.flight
      }, /*#__PURE__*/React.createElement("td", {
        className: "name"
      }, g.flight), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, num(g.rows.length)), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, num(g.agg.impressions)), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, num(g.agg.clicks)), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, pct(g.agg.ctr)))))));
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
        title: "Best CTR — campaigns with 1,000+ impressions"
      }, /*#__PURE__*/React.createElement("table", {
        className: "territory-table wa-table"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Campaign"), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Impressions"), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Clicks"), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "CTR"))), /*#__PURE__*/React.createElement("tbody", null, ins.byCtr.map(r => {
        const pn = parseName(r.name);
        return /*#__PURE__*/React.createElement("tr", {
          key: r.id,
          className: "clickable",
          onClick: this.openCampaign(r.id)
        }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
          className: "name"
        }, pn.flight), /*#__PURE__*/React.createElement("span", {
          className: "code"
        }, channelLabel(r.type), pn.market ? ` · ${pn.market}` : "")), /*#__PURE__*/React.createElement("td", {
          className: "n"
        }, num((r.metrics || {}).impressions)), /*#__PURE__*/React.createElement("td", {
          className: "n"
        }, num((r.metrics || {}).clicks)), /*#__PURE__*/React.createElement("td", {
          className: "r strong"
        }, pct((r.metrics || {}).ctr)));
      })))), /*#__PURE__*/React.createElement(Card, {
        title: "Most Clicks"
      }, /*#__PURE__*/React.createElement("table", {
        className: "territory-table wa-table"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Campaign"), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Impressions"), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Clicks"), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "CTR"))), /*#__PURE__*/React.createElement("tbody", null, ins.byClicks.map(r => {
        const pn = parseName(r.name);
        return /*#__PURE__*/React.createElement("tr", {
          key: r.id,
          className: "clickable",
          onClick: this.openCampaign(r.id)
        }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
          className: "name"
        }, pn.flight), /*#__PURE__*/React.createElement("span", {
          className: "code"
        }, channelLabel(r.type), pn.market ? ` · ${pn.market}` : "")), /*#__PURE__*/React.createElement("td", {
          className: "n"
        }, num((r.metrics || {}).impressions)), /*#__PURE__*/React.createElement("td", {
          className: "r strong"
        }, num((r.metrics || {}).clicks)), /*#__PURE__*/React.createElement("td", {
          className: "n"
        }, pct((r.metrics || {}).ctr)));
      })))), groupTable("Top Flights", ins.topFlights, "Flight"), groupTable("Top Markets", ins.topMarkets, "Market"), groupTable("By Channel", ins.channelAgg.map(c => ({
        flight: c.channel,
        rows: c.rows,
        agg: c.agg
      })), "Channel"));
    })() : /*#__PURE__*/React.createElement(Card, {
      title: grouping === "flight" ? "Flights" : grouping === "market" ? "Markets" : "Campaigns"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: "10px",
        alignItems: "center",
        marginBottom: "10px"
      }
    }, /*#__PURE__*/React.createElement("input", {
      value: q,
      placeholder: "Search flight, campaign, market\u2026",
      onChange: e => this.setState({
        q: e.target.value,
        shownFlights: FLIGHTS_PAGE
      }),
      style: {
        width: "300px",
        padding: "8px 10px",
        border: "1px solid var(--plk-border)",
        borderRadius: "6px",
        fontSize: "13px"
      }
    })), grouping !== "flat" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, grouping === "market" ? "Market" : "Flight"), /*#__PURE__*/React.createElement("th", null, "Channels"), /*#__PURE__*/React.createElement("th", null, grouping === "market" ? "Flights" : "Markets"), /*#__PURE__*/React.createElement("th", null, "Status"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Impressions"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Clicks"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "CTR"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Conversions"), this._videoOn ? /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Video Views") : null, moneyVisible ? /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Spend") : null, moneyVisible ? /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Budget") : null)), /*#__PURE__*/React.createElement("tbody", null, pendingFlights.slice(0, 25).map(f => /*#__PURE__*/React.createElement("tr", {
      key: `pending-${f.id}`,
      className: "clickable",
      onClick: () => this.props.history.push(`/Campaigns/FlightBuilder/${f.id}`),
      title: "Open in Flight Builder"
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, f.eventName || f.name), /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, f.createdDate ? String(f.createdDate).slice(0, 10) : ""), isFlightAdmin && /*#__PURE__*/React.createElement("span", {
      onClick: e => e.stopPropagation(),
      style: {
        marginLeft: 10,
        fontSize: 12,
        whiteSpace: "nowrap"
      }
    }, /*#__PURE__*/React.createElement("a", {
      style: {
        cursor: "pointer",
        color: "var(--plk-accent)"
      },
      title: "Edit in Flight Builder",
      onClick: () => this.props.history.push(`/Campaigns/FlightBuilder/${f.id}`)
    }, "edit"), /*#__PURE__*/React.createElement("span", {
      style: {
        color: "var(--plk-text-dim)",
        margin: "0 6px"
      }
    }, "\xB7"), /*#__PURE__*/React.createElement("a", {
      style: {
        cursor: this.state.flightBusy ? "wait" : "pointer",
        color: "var(--plk-danger,#b42318)"
      },
      title: "Delete this flight",
      onClick: () => this.deleteFlight(f.id, f.eventName || f.name)
    }, "delete"))), /*#__PURE__*/React.createElement("td", null, (f.channels || []).map(c => /*#__PURE__*/React.createElement("span", {
      key: c,
      className: "code",
      style: {
        marginRight: 4
      }
    }, channelLabel(c)))), /*#__PURE__*/React.createElement("td", null, Array.isArray(f.markets) ? f.markets.length : "—"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "cust-stage",
      style: {
        background: "#eef0f3",
        color: "#55606e"
      }
    }, f.status)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, "\u2014"), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, "\u2014"), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, "\u2014"), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, "\u2014"), this._videoOn ? /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, "\u2014") : null, moneyVisible ? /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, "\u2014") : null, moneyVisible ? /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, "\u2014") : null)), flights.slice(0, shownFlights).map(f => {
      const fid = this.resolveFlightId(f);
      const flightDailyBudget = f.rows.reduce((s, r) => s + (!isRemovedStatus(r.status) ? budgetDollars(r.budget, r.provider) || 0 : 0), 0);
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: f.flight
      }, /*#__PURE__*/React.createElement("tr", {
        className: "clickable",
        onClick: () => this.setState({
          expanded: {
            ...expanded,
            [f.flight]: !expanded[f.flight]
          }
        }),
        title: expanded[f.flight] ? "Collapse" : "Expand campaigns"
      }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
        className: "name"
      }, expanded[f.flight] ? "▾ " : "▸ ", f.flight), isFlightAdmin && /*#__PURE__*/React.createElement("span", {
        onClick: e => e.stopPropagation(),
        style: {
          marginLeft: 10,
          fontSize: 12,
          whiteSpace: "nowrap"
        }
      }, fid ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
        style: {
          cursor: "pointer",
          color: "var(--plk-accent)"
        },
        title: "Open flight detail",
        onClick: () => this.openFlight(fid)
      }, "details"), /*#__PURE__*/React.createElement("span", {
        style: {
          color: "var(--plk-text-dim)",
          margin: "0 6px"
        }
      }, "\xB7"), /*#__PURE__*/React.createElement("a", {
        style: {
          cursor: "pointer",
          color: "var(--plk-accent)"
        },
        title: "Edit in Flight Builder",
        onClick: () => this.props.history.push(`/Campaigns/FlightBuilder/${fid}`)
      }, "edit"), (f.enabled > 0 || f.paused > 0) && /*#__PURE__*/React.createElement("span", {
        style: {
          color: "var(--plk-text-dim)",
          margin: "0 6px"
        }
      }, "\xB7"), (f.enabled > 0 || f.paused > 0) && /*#__PURE__*/React.createElement("a", {
        style: {
          cursor: this.state.flightBusy ? "wait" : "pointer",
          color: "var(--plk-accent)"
        },
        title: f.enabled > 0 ? "Pause every campaign in this flight" : "Resume every campaign in this flight",
        onClick: () => this.flightAction(fid, f.enabled > 0 ? "Paused" : "Enabled")
      }, f.enabled > 0 ? "pause" : "resume"), /*#__PURE__*/React.createElement("span", {
        style: {
          color: "var(--plk-text-dim)",
          margin: "0 6px"
        }
      }, "\xB7"), /*#__PURE__*/React.createElement("a", {
        style: {
          cursor: this.state.flightBusy ? "wait" : "pointer",
          color: "var(--plk-danger,#b42318)"
        },
        title: "Delete this flight (pauses its campaigns)",
        onClick: () => this.deleteFlight(fid, f.flight)
      }, "delete")) : /*#__PURE__*/React.createElement(React.Fragment, null, (f.enabled > 0 || f.paused > 0) && /*#__PURE__*/React.createElement("a", {
        style: {
          cursor: this.state.flightBusy ? "wait" : "pointer",
          color: "var(--plk-accent)"
        },
        title: f.enabled > 0 ? "Pause these campaigns" : "Resume these campaigns",
        onClick: () => this.groupStatus(f.rows, f.enabled > 0 ? "Paused" : "Enabled")
      }, f.enabled > 0 ? "pause" : "resume"), (f.enabled > 0 || f.paused > 0) && /*#__PURE__*/React.createElement("span", {
        style: {
          color: "var(--plk-text-dim)",
          margin: "0 6px"
        }
      }, "\xB7"), /*#__PURE__*/React.createElement("a", {
        style: {
          cursor: this.state.flightBusy ? "wait" : "pointer",
          color: "var(--plk-danger,#b42318)"
        },
        title: "Remove these campaigns from Plunk",
        onClick: () => this.groupRemove(f)
      }, "remove")))), /*#__PURE__*/React.createElement("td", null, [...f.channels].join(" · ")), /*#__PURE__*/React.createElement("td", null, f.markets.size || "—"), /*#__PURE__*/React.createElement("td", {
        style: {
          whiteSpace: "nowrap"
        }
      }, f.enabled > 0 && /*#__PURE__*/React.createElement("span", {
        className: "cust-stage",
        style: {
          background: "#e5f3ec",
          color: "#217a4b"
        }
      }, f.enabled, " active"), f.paused > 0 && /*#__PURE__*/React.createElement("span", {
        className: "cust-stage",
        style: {
          background: "var(--plk-surface-alt)",
          color: "var(--plk-text-dim)",
          marginLeft: "4px"
        }
      }, f.paused, " paused"), f.removed > 0 && /*#__PURE__*/React.createElement("span", {
        className: "cust-stage",
        style: {
          background: "var(--plk-danger-soft,#fbe6e5)",
          color: "var(--plk-danger,#d64541)",
          marginLeft: "4px"
        }
      }, f.removed, " deleted")), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, num(f.agg.impressions)), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, num(f.agg.clicks)), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, pct(f.agg.ctr)), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, num(f.agg.conversions)), this._videoOn ? /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, Number(f.agg.videoViews) > 0 ? num(f.agg.videoViews) : "—") : null, moneyVisible ? /*#__PURE__*/React.createElement("td", {
        className: "r strong"
      }, usd(f.agg.spend)) : null, moneyVisible ? /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, flightDailyBudget > 0 ? `${usd(flightDailyBudget)}/day` : "—") : null), expanded[f.flight] ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        colSpan: cols + 2,
        style: {
          padding: 0,
          background: "var(--plk-surface-alt)"
        }
      }, /*#__PURE__*/React.createElement("table", {
        className: "territory-table wa-table",
        style: {
          margin: 0
        }
      }, /*#__PURE__*/React.createElement("tbody", null, f.rows.slice().sort((a, b) => (Number((b.metrics || {}).impressions) || 0) - (Number((a.metrics || {}).impressions) || 0)).map(r => this.renderCampaignRow(r, moneyVisible, true)))))) : null);
    }))), flights.length > shownFlights && /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-button-solid k-button-solid-base",
      style: {
        marginTop: "12px"
      },
      onClick: () => this.setState({
        shownFlights: shownFlights + FLIGHTS_PAGE
      })
    }, "Load more (", flights.length - shownFlights, " more flights)"), !flights.length && !loading && /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "No campaigns match.")) : /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Campaign"), /*#__PURE__*/React.createElement("th", null, "Status"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Impressions"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Clicks"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "CTR"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Conversions"), this._videoOn ? /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Video Views") : null, this._roasOn ? /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Revenue") : null, this._roasOn ? /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "ROAS") : null, this._roasOn ? /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "CPA") : null, moneyVisible ? /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Spend") : null, moneyVisible ? /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Budget") : null)), /*#__PURE__*/React.createElement("tbody", null, rows.slice().sort((a, b) => (Number((b.metrics || {}).impressions) || 0) - (Number((a.metrics || {}).impressions) || 0)).slice(0, 100).map(r => this.renderCampaignRow(r, moneyVisible, false)))))));
  }
}
export default withRouter(CampaignsViewComponent);